<script>
import { Col } from 'element-ui';

export default {
  extends: Col,
};
</script>

<style lang="scss">
  .el-col {
    padding-left: rem(15px);
    padding-right: rem(15px);
  }
</style>
